import React from 'react';
import LoginForm from '../../components/auth/LoginForm';
import { Box, Container, Heading, Flex, Badge } from '@chakra-ui/react';

const LoginPage = () => {
  const bgGradient = "var(--gradient-auth)";
  
  return (
    <Box 
      minH="100vh" 
      bg={bgGradient}
      position="relative"
      py={16}
      display="flex"
      alignItems="center"
      overflow="hidden"
    >
      {/* Abstract background elements */}
      <Box position="absolute" top="-100px" left="-50px" w="300px" h="300px" borderRadius="full" bg="blue.100" opacity="0.3" filter="blur(70px)" />
      <Box position="absolute" bottom="-100px" right="-50px" w="350px" h="350px" borderRadius="full" bg="purple.100" opacity="0.3" filter="blur(70px)" />
      
      <Container maxW="container.xl" position="relative" zIndex={1}>
        <Flex direction="column" alignItems="center">
          
          <Heading 
            as="h1" 
            size="xl" 
            mb={6} 
            textAlign="center"
            bgGradient="var(--gradient-text-primary)"
            bgClip="text"
            lineHeight="1.2"
            fontWeight="bold"
          >
            Access Your Account
          </Heading>
          
          
          
          <LoginForm />
        </Flex>
      </Container>
    </Box>
  );
};

export default LoginPage;